import {defineMessages} from 'react-intl';

export default defineMessages({
  sending: {
    id: 'ciscospark.container.message.sending',
    defaultMessage: 'Sending...'
  },
  sent: {
    id: 'ciscospark.container.message.sent',
    defaultMessage: 'Sent'
  },
  unableToSendYourRequest: {
    id: 'ciscospark.container.message.UnabletoSendYourRequest',
    defaultMessage: 'Unable to send your request'
  }
});
